export const resolveFullSnippetPath = (relativePath: string) => {
  return `https://www.paypalobjects.com/ppdevdocs/v2noapi${relativePath}`
}
